import { render } from "./LeadMgt.vue?vue&type=template&id=05d8f078"
import script from "./LeadMgt.vue?vue&type=script&lang=js"
export * from "./LeadMgt.vue?vue&type=script&lang=js"

import "./LeadMgt.vue?vue&type=style&index=0&id=05d8f078&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__